<template>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
        <v-card
            :loading="isLoading"
        >
            <v-toolbar
                dark
                color="primary"
            >
                <v-btn
                    icon
                    dark
                    @click="dialog = false"
                    :disabled="isSaving"
                >
                    <v-icon>
                        mdi-close
                    </v-icon>
                </v-btn>
                <v-toolbar-title>
                    {{ $t('tourbook.change.title') }}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container
                    v-if="!isLoading"
                    class="ma-0"
                    fluid
                >
                    <day
                        v-for="(day, key) in itinerary"
                        v-model="itinerary[key]"
                        :key="day.id"
                        :base-cols="12"
                        class="mb-8"
                        ref="days"
                    >
                        <h2>
                            {{ $t('day.day') }}
                            <span>
                                {{ day.dayFrom }}
                            </span>
                            <span>
                                - {{ day.dayTo }}
                            </span>
                        </h2>
                    </day>
                    <v-footer
                        app
                    >
                        <v-progress-linear
                            v-if="isSaving || isLoading"
                            indeterminate
                            primary
                        />
                        <v-container
                            class="d-flex"
                        >
                            <v-btn
                                text
                                @click="dialog = false"
                                :disabled="isSaving"
                            >
                                {{ $t('action.cancel') }}
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="secondary"
                                @click="saveChanges"
                                :disabled="this.isSaving"
                            >
                                {{ $t('action.save') }}
                            </v-btn>
                        </v-container>
                    </v-footer>
                </v-container>
                <v-container
                    v-else
                >
                    <v-skeleton-loader
                        type="card"
                    >
                    </v-skeleton-loader>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import axios from 'axios';
import Day from "@/components/Trip/Form/Itinerary/Day";
import {SnackBarAction, SnackBarTypes} from "@/store/snackbar/types";
import {mapActions} from "vuex";
import {TourbookAction} from "@/store/tourbook/types";

export default {
    components: {
        Day,
    },
    props: {
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
        schedule: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        isLoading: true,
        itinerary: [],
        originalData: [],
        isSaving: false,
    }),
    watch: {
        dialog: function (newValue) {
            if(newValue) {
                this.isLoading = true;
                this.itinerary = [];

                axios
                    .get(`/tourbook/${this.schedule.id}/itinerary`)
                    .then(resp => {
                        return resp.data;
                    })
                    .then(data => {
                        this.originalData = JSON.parse(JSON.stringify(data));
                        this.itinerary = data;
                        this.isLoading = false;
                    });
            }
        },
    },
    computed: {
        dialog: {
            get: function() {
                return this.value;
            },
            set: function(newValue) {
                this.$emit('input', newValue);
            }
        },
    },
    methods: {
        ...mapActions({
            updateTourbook: `tourbook/${TourbookAction.UPDATE}`,
            setSnackbar: `snackbar/${SnackBarAction.SET}`,
        }),
        saveChanges() {
            let isInvalid = false;
            let isDirty = false;
            this.$refs.days.forEach((day) => {
                if(day.$v.$anyDirty) {
                    isDirty = true;
                }

                if(day.$v.$invalid) {
                    isInvalid = true;
                }
            });

            if(!isDirty) {
                this.setSnackbar(
                    {
                        data: this.$t('tourbook.snackbar.performChanges'),
                        type: SnackBarTypes.WARNING,
                    }
                );
                return;
            }

            if(isInvalid) {
                this.setSnackbar(
                    {
                        data: this.$t('tourbook.snackbar.fixErrors'),
                        type: SnackBarTypes.WARNING,
                    }
                );
                return;
            }

            this.isSaving = true;
            // Map data to detect changes on the server easily
            const changedData = JSON.parse(JSON.stringify(this.itinerary));
            changedData.forEach((entry, index) => {
                entry._changed = JSON.stringify(entry) !== JSON.stringify(this.originalData[index]);
            });

            this.updateTourbook({
                    schedule: this.schedule,
                    data: changedData,
                })
                .then(() => {
                    this.dialog = false;
                    this.setSnackbar({
                        data: this.$t('tourbook.snackbar.saveSuccess'),
                        type: SnackBarTypes.SUCCESS
                    });
                })
                .catch(() => {
                    this.setSnackbar({
                        data: this.$t('tourbook.snackbar.saveFailure'),
                        type: SnackBarTypes.ERROR
                    });
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
    }
}
</script>
